export enum JOBS_HOMES_HEADERS {
  STATUS = 'status',
  NAME = 'name',
  UPDATED = 'updated',
  SOFT_VERSION = 'softwareVersion',
  SUBSCR_PLAN = 'subscriptionPlan',
  SUBSCR_ENDS = 'subscriptionEnds',
  LAST_BACKUP = 'lastBackup',
}
